import { FC, useMemo } from 'react';

import Checkbox from '@components/Checkbox';
import { FlexibleDiv } from '@components/formStyles';

import { MonthItem } from '../interface';
import { YearMonthItem, YearMonthsItems, YearTabWrapper } from '../styled';

interface Props {
  months: MonthItem[];
  handleMonthChange: (month: string, checked: boolean) => void;
  toggleAllMonths: (val: boolean) => void;
}

const YearTab: FC<Props> = ({ months, handleMonthChange, toggleAllMonths }) => {
  const allMonthsSelected = useMemo(() => {
    return months.every((month) => month.checked);
  }, [months]);

  return (
    <YearTabWrapper>
      <YearMonthsItems>
        {months.map((currentMonth) => (
          <FlexibleDiv key={currentMonth.name}>
            <YearMonthItem>
              <Checkbox
                title={currentMonth.name}
                checked={currentMonth.checked}
                onChange={(val) => handleMonthChange(currentMonth.name, val)}
                mode='controlled'
              />
            </YearMonthItem>
          </FlexibleDiv>
        ))}
      </YearMonthsItems>

      <Checkbox
        title='Tüm Dönem'
        mode='controlled'
        checked={allMonthsSelected}
        onChange={(val) => toggleAllMonths(val)}
      />
    </YearTabWrapper>
  );
};

export default YearTab;
